"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNewsletter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var router_1 = require("next/router");
var react_hook_form_1 = require("react-hook-form");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var __1 = require("../");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var i18n_1 = require("../../i18n");
var Form = styled_components_1.default.form(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  > div {\n    align-items: flex-end;\n    display: flex;\n\n  }\n\n  button {\n    &[type='submit'] {\n      margin-left: ", ";\n      height: ", ";\n\n      ", "\n    }\n  }\n\n  .input--newsletter {\n    margin-bottom: 0;\n\n    input {\n      color: white;\n    }\n  }\n\n  .subtext {\n    ", "\n    color: ", ";\n    font-size: ", ";\n    margin-top: ", ";\n    opacity: 0;\n    height: 0;\n    transition: all .3s ", ";\n\n    ", "\n\n    &.show {\n      opacity: 1;\n      height: ", ";\n      ", "\n    }\n  }\n"], ["\n  > div {\n    align-items: flex-end;\n    display: flex;\n\n  }\n\n  button {\n    &[type='submit'] {\n      margin-left: ", ";\n      height: ", ";\n\n      ", "\n    }\n  }\n\n  .input--newsletter {\n    margin-bottom: 0;\n\n    input {\n      color: white;\n    }\n  }\n\n  .subtext {\n    ", "\n    color: ", ";\n    font-size: ", ";\n    margin-top: ", ";\n    opacity: 0;\n    height: 0;\n    transition: all .3s ", ";\n\n    ", "\n\n    &.show {\n      opacity: 1;\n      height: ", ";\n      ", "\n    }\n  }\n"])), (0, styles_1.getRelative)(14, 'mobile'), (0, styles_1.getRelative)(50, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        margin-left: ", ";\n        height: ", ";\n      "], ["\n        margin-left: ", ";\n        height: ", ";\n      "])), (0, styles_1.getRelative)(16, 'desktop'), (0, styles_1.getRelative)(43, 'desktop')), (0, styles_1.getP12_1)(), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, (0, styles_1.getRelative)(10, 'mobile'), (0, styles_1.getRelative)(10, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: ", ";\n      margin-top: ", ";\n    "], ["\n      font-size: ", ";\n      margin-top: ", ";\n    "])), (0, styles_1.getRelative)(10, 'desktop'), (0, styles_1.getRelative)(10, 'desktop')), (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        height: 100%\n    "], ["\n        height: 100%\n    "]))));
var MESSAGES = {
    'es': {
        'success': 'Gracias! Te mantendremos informado sobre las últimas novedades',
        'error': 'Hubo un problema enviando el formulario. Por favor inténtelo de nuevo más tarde',
        'duplicated': 'Email ya esta dado de alta'
    },
    'en': {
        'success': 'Thanks! We will keep you informed about the latest news',
        'error': 'There was a problem submitting the form. Please try again later',
        'duplicated': 'Email is already registered'
    },
    'fr': {
        'success': 'Merci ! Nous vous tiendrons au courant des dernières nouvelles',
        'error': 'Il y a eu un problème lors de l\'envoi du formulaire. Veuillez réessayer plus tard',
        'duplicated': 'L\'adresse e-mail est déjà utilisée'
    },
};
var DEFAULT_LOCALE = process.env.NEXT_PUBLIC_LOCALE;
var TRANSLATIONS = {
    email_message_en: 'Please, enter a valid email',
};
exports.FormNewsletter = (0, react_1.memo)(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = _a.showSmallPrint, showSmallPrint = _k === void 0 ? false : _k, _l = _a.showLegend, showLegend = _l === void 0 ? true : _l;
    var _m = (0, react_hook_form_1.useForm)(), register = _m.register, errors = _m.errors, handleSubmit = _m.handleSubmit;
    var _o = __read((0, react_1.useState)(false), 2), showSubtext = _o[0], setShowSubtext = _o[1];
    var _p = (0, hooks_1.useToast)(), Container = _p.Container, addToast = _p.addToast, toasts = _p.toasts;
    var layout = (0, i18n_1.usei18n)().layout;
    var locale = ((0, router_1.useRouter)() || { locale: DEFAULT_LOCALE }).locale;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, utils_1.subscribe)({ body: data })];
                case 1:
                    success = _a.sent();
                    if (typeof success === 'boolean' && success) {
                        addToast({ children: MESSAGES[locale].success, type: 'success' });
                    }
                    else if (typeof success === 'string') {
                        addToast({ children: MESSAGES[locale].duplicated, type: 'success' });
                    }
                    else {
                        addToast({ children: MESSAGES[locale].error, type: 'error' });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onFocus = function () {
        setShowSubtext(true);
    };
    var onBlur = function () {
        setShowSubtext(false);
    };
    var errorMail = Object.keys(errors).length && errors.email ? true : false;
    return ((0, jsx_runtime_1.jsxs)(Form, __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [showLegend && (0, jsx_runtime_1.jsx)("legend", { children: (0, jsx_runtime_1.jsx)("h2", { children: (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.footer) === null || _b === void 0 ? void 0 : _b.newsletter) === null || _c === void 0 ? void 0 : _c.title }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(__1.Input, { type: 'email', placeHolderAlwaysActive: true, className: 'input--newsletter', placeholder: (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.footer) === null || _d === void 0 ? void 0 : _d.newsletter) === null || _e === void 0 ? void 0 : _e.input_inactive, ref: register({ required: true, pattern: __1.INPUT_PATTERNS.email }), name: 'email', error: errorMail, errorMessage: locale === 'en' ? TRANSLATIONS.email_message_en : __1.INPUT_PATTERNS.email_message, textColor: 'light', onBlur: onBlur, onFocus: onFocus }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: 'submit', bgType: 'white' }, { children: (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.footer) === null || _f === void 0 ? void 0 : _f.newsletter) === null || _g === void 0 ? void 0 : _g.button }))] }), showSmallPrint && (0, jsx_runtime_1.jsx)("div", __assign({ className: "subtext ".concat(showSubtext ? 'show' : '') }, { children: (_j = (_h = layout === null || layout === void 0 ? void 0 : layout.footer) === null || _h === void 0 ? void 0 : _h.newsletter) === null || _j === void 0 ? void 0 : _j.subtext })), (0, jsx_runtime_1.jsx)(Container, { toasts: toasts })] })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
